<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header"><img src="../assets/images/pizza.png" /></slot>
          </div>

          <div class="modal-body">
            <slot name="body"
              >Click 'I agree' to indicate that you have read and accept the
              Just Eat Takeaway.com Brand Box guidelines
              <a href="/terms-and-conditions" target="_blank"
                >Terms and Conditions</a
              >
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="closeModal">
                I agree
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  methods: {
    closeModal() {
      this.$emit('closeModal')
      this.$cookie.set('terms-accepted', true)
      this.$cookie.set('cookies-accepted', true)
    },
  },
}
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 128, 0, 0.7);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: var(--color-mozzarella-1);
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  text-align: center;
  margin-top: 100px;
}

.modal-header {
  margin-top: -75px;
  img {
    width: 150px;
  }
}

.modal-body {
  margin: 20px 0;
  color: var(--color-charcoal-1);
  a {
    color: var(--color-orange-1);
    font-weight: 600;
  }
}

.modal-default-button {
  background-color: transparent;
  color: var(--color-charcoal-1);
  font-size: 16px;
  margin: 10px;
  padding: 10px;
  border: 2px solid var(--color-charcoal-1);
  cursor: pointer;
  width: 200px;
  &:hover {
    opacity: 0.9;
    transform: scale(1.02);
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>